import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SalesTargetEditPageRoutingModule } from './sales-target-edit-routing.module';

import { SalesTargetEditPage } from './sales-target-edit.page';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SalesTargetEditPageRoutingModule,
    ReactiveFormsModule,
    NgxDatatableModule
  ],
  declarations: [SalesTargetEditPage]
})
export class SalesTargetEditPageModule {}
